<template>
  <div class="login-container">
    <!-- System logo and background on the left side -->
    <div class="system-branding">
      <div class="logo-container">
        <h1 class="system-name">极客码艺后台管理系统</h1>
        <p class="system-slogan">专业·高效·共赢</p>
      </div>
    </div>

    <!-- Login form on the right -->
    <div class="login-panel">
      <div class="login-content">
        <div class="login-header">
          <h2 class="login-title">欢迎登录</h2>
          <p class="login-subtitle">极客码艺后台管理平台</p>
        </div>

        <el-form ref="userForm" :model="user" :rules="rules" class="login-form">
          <el-form-item prop="username" class="custom-form-item">
            <el-input
                v-model="user.username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user">
            </el-input>
          </el-form-item>

          <el-form-item prop="password" class="custom-form-item">
            <el-input
                v-model="user.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                show-password>
            </el-input>
          </el-form-item>

          <el-form-item prop="captchaCode" class="custom-form-item">
            <el-input
                v-model="user.captchaCode"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key">
              <template slot="append">
                <div class="captcha-container" @click="refreshCaptcha">
                  <span v-if="captchaLoading">加载中...</span>
                  <span v-else class="captcha-code">{{ captchaValue }}</span>
                  <i class="el-icon-refresh captcha-refresh"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <div class="button-group">
            <el-button type="primary" class="login-btn" @click="login">登录</el-button>
          </div>

          <div class="footer-info">
            <p>© 2024 极客码艺后台管理系统</p>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {resetRouter, setRoutes} from "@/router";

export default {
  name: "Login",
  data() {
    return {
      user: {
        username: '',
        password: '',
        captchaCode: ''
      },
      captchaValue: '',
      captchaLoading: false,
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
        ],
        captchaCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 6, message: '请输入正确的验证码', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    resetRouter()
  },
  mounted() {
    this.refreshCaptcha();
  },
  methods: {
    refreshCaptcha() {
      this.captchaLoading = true;
      this.captchaValue = '';
      this.user.captchaCode = '';

      this.request.post("/user/generate_captcha").then(res => {
        if (res.code === '200') {
          this.captchaValue = res.data;
        } else {
          this.$message.error("获取验证码失败");
        }
        this.captchaLoading = false;
      }).catch(() => {
        this.$message.error("获取验证码失败");
        this.captchaLoading = false;
      });
    },
    login() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          if (this.user.captchaCode.toLowerCase() !== this.captchaValue.toLowerCase()) {
            this.$message.error("验证码错误");
            this.refreshCaptcha();
            return;
          }

          this.request.post("/user/login", this.user).then(res => {
            if (res.code === '200') {
              localStorage.setItem("user", JSON.stringify(res.data))
              localStorage.setItem("menus", JSON.stringify(res.data.menus))
              setRoutes()
              this.$router.push("/home")
              this.$message.success("登录成功")
            } else {
              this.$message.error(res.msg)
              this.refreshCaptcha();
            }
          })
        }
      });
    }
  }
}
</script>

<style>
.login-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  display: flex;
}

.login-panel {
  width: 520px;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);
  position: relative;
}

.login-content {
  width: 85%;
  max-width: 420px;
}

.system-branding {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
  background: url('https://img.freepik.com/free-vector/business-team-putting-together-jigsaw-puzzle-isolated-flat-vector-illustration-cartoon-partners-working-connection-teamwork-partnership-cooperation-concept_74855-9814.jpg') center/cover no-repeat;
}

.system-branding::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: -1;
}

.logo-container {
  text-align: center;
  color: white;
  max-width: 600px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  z-index: 1;
}

.system-name {
  font-size: 42px;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 2;
}

.system-slogan {
  font-size: 24px;
  margin: 20px 0 0;
  letter-spacing: 8px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 2;
  font-weight: 300;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.login-subtitle {
  color: #666;
  font-size: 16px;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.custom-form-item {
  margin-bottom: 25px;
}

.custom-form-item .el-input__inner {
  height: 50px;
  border-radius: 5px;
  padding-left: 55px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
  font-size: 16px;
  line-height: 50px;
}

.custom-form-item .el-input__prefix {
  top:3px;
  left: 20px;
  height: 100%;
  display: flex;
  align-items: center;
}

.custom-form-item .el-input__prefix i {
  font-size: 22px;
  color: #909399;
  line-height: 1;
}

.custom-form-item .el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.custom-form-item .el-input__inner:focus + .el-input__prefix i {
  color: #409EFF;
}

.button-group {
  margin-bottom: 40px;
}

.login-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  letter-spacing: 1px;
  background-color: #409EFF;
  border-color: #409EFF;
}

.login-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.footer-info {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin-top: 30px;
}

.captcha-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 100px;
  cursor: pointer;
  padding: 0 10px;
  height: 100%;
  user-select: none;
}

.captcha-code {
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 2px;
  color: #409EFF;
  margin-right: 5px;
}

.captcha-refresh {
  color: #909399;
  font-size: 16px;
}

.captcha-container:hover .captcha-refresh {
  color: #409EFF;
}

@media screen and (max-width: 992px) {
  .login-container {
    flex-direction: column-reverse;
  }

  .login-panel {
    width: 100%;
    height: 100%;
  }

  .system-branding {
    display: none;
  }

  .login-content {
    padding: 30px 20px;
  }
}
</style>
